import { inject, Injectable } from '@angular/core';
import { PlatformService } from '@core/services/platform.service';
import { captureException } from '@sentry/angular';
import { BehaviorSubject } from 'rxjs';

export type SubscribeErrorType =
  | 'LOAD-USER'
  | 'LOAD-SOMEDATA'
  | 'LOAD-FILE'
  | 'CANT-LOGIN'
  | 'SOCKET-ERROR'
  | 'PROFILE-PROBLEM'
  | 'PAYMENT-PROBLEM'
  | 'SAVE-PROBLEM'
  | 'OTHER-PROBLEM';

export interface SubscribeError {
  id: string;
  error: any;
  type: SubscribeErrorType;
  sentryErrorId: string;
}

export interface ShowAdditionalInfo {
  status: boolean;
  info: string;
}

export const TIMER_DURATION = 10; // в секундах

@Injectable({
  providedIn: 'root',
})
export class ErrorNotificationService {
  protected readonly platform = inject(PlatformService);

  private errors: SubscribeError[] = [];
  private error = new BehaviorSubject<SubscribeError[]>([]);
  public error$ = this.error.asObservable();

  public captureError(error: any, errorType: SubscribeErrorType = 'OTHER-PROBLEM') {
    const newError = new Error(error);
    const errorId = captureException(error, (scope) => {
      scope.clear();
      scope.setTransactionName(`${newError.message} [YELLOW MESSAGE]`);
      return scope;
    });
    // this.showErrorNotification({
    //   id: Date.now().toString(),
    //   error,
    //   type: errorType,
    //   sentryErrorId: errorId,
    // });
  }

  public showErrorNotification(error: SubscribeError) {
    if (this.errors.length) {
      const errorExist = this.errors.some((errors) => errors.id === error.id);
      if (!errorExist) {
        this.errors.unshift(error);
        this.error.next(this.errors);
      }
    } else {
      this.errors.unshift(error);
      this.error.next(this.errors);
    }
  }

  public closeError(error: SubscribeError) {
    this.errors = this.errors.filter((errors) => errors.id !== error.id);
    this.error.next(this.errors);
  }
}
